<template>
  <v-avatar
      :style="{
      'background-color': itemColor(item),
      'max-width':$vuetify.breakpoint.xsOnly? xsSize+'px':smSize+'px',
      'max-height':$vuetify.breakpoint.xsOnly? xsSize+'px':smSize+'px'
      }"
  >
    <img v-if="itemAvatar(item) " :src="itemAvatar(item) " :alt="item.name">
    <span v-else class="white--text" :style="'font-size:' + fontSize +'px'"
    >{{item.name.charAt(0).toUpperCase()}}</span>
  </v-avatar>
</template>

<script>
  import colorHelper from '~/helpers/color'
  export default {
    name: 'ProvisionalAvatar',
    props: {
      item: {
        type: Object,
        required: true
      },
      xsSize: {
        type: String,
        default: '30'
      },
      smSize: {
        type: String,
        default: '40'
      },
      fontSize: {
        type: String,
        default: '25'
      }
    },
    methods: {
      itemColor (item) {
        return colorHelper.fromName(item.name)
      },
      itemAvatar (item) {
        return null /* Api.config.apiUrl +
          this.itemType(item) +
          '/' + this.itemID(item) +
          '/avatar/' + item.avatar */
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/ProvisionalAvatar.vue